import 'sticky-kit/dist/sticky-kit.min'
import Swiper from "swiper/core"
import {Scrollbar, Zoom as SwipeZoom} from "swiper/modules"
import 'swiper/css';
import 'swiper/css/zoom';
// import "../product-minature"
import {productsCarouselConfig} from "../products-carousel.config";
import ProductZoom from "../ProductZoom";

// Thumbs vertical carousel
new Swiper('.product__thumbs .swiper', {
    createElements: true,
    direction: 'vertical',
    slidesPerView: "auto"
})

// Bottom products carousel
new Swiper('.products__carousel', productsCarouselConfig)

// Description toggle
$(".product__desc-toggle").click(function () {
    $(this).toggleClass('active')
})

// Thumbs click
$('.product__thumb').click(function () {
    $([document.documentElement, document.body]).animate({
        scrollTop: $('.product__image').eq($(this).index()).offset().top - parseInt(window.app.getCustomCSSProperty('header-height')),
    }, 500, "linear")
})

// Active thumb
const productImages = $(".product__image");
const setActiveThumb = () => {
    let current = 0
    productImages.each(function (index) {
        if ((window.scrollY + window.innerHeight / 2) >= $(this).offset().top) {
            current = index
        }
    });
    $(".product__thumb")
        .removeClass('active')
        .eq(current).addClass('active')
}

/**
 * @var {Swiper} mainImagesSwiper
 */
let mainImagesSwiper;
const $stickyThumbs = $(".product__thumbs-inner")
const $stickyRight = $(".product__right-inner")
/**
 * @var {ProductZoom} Zoom
 */
let Zoom;
const mql = window.matchMedia('(min-width:768px)');
const breakpointListener = () => {
    if (mql.matches) {
        window.addEventListener('scroll', setActiveThumb)
        window.addEventListener('DOMContentLoaded', setActiveThumb)
        $stickyThumbs.stick_in_parent()
        $stickyRight.stick_in_parent()
        mainImagesSwiper !== undefined && mainImagesSwiper.destroy();
        Zoom = new ProductZoom(document.querySelector('.product__images .swiper'));
        return;
    }
    Zoom && Zoom.destroy()
    $stickyThumbs.trigger("sticky_kit:detach")
    $stickyRight.trigger("sticky_kit:detach")
    mainImagesSwiper = new Swiper('.product__images .swiper', {
        modules: [Scrollbar],
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
    })
    window.removeEventListener('scroll', setActiveThumb)
};
mql.addEventListener("change", breakpointListener);
breakpointListener()

// Mobile popup
if ($(window).width() <= 768) {
    $('.product__image img').on('click', function (e) {
        e.preventDefault();
        let imageUrl = $(this).attr('src');
        let imageAlt = $(this).attr('alt');

        let modal = $(`
        <div class="zoom-modal">
            <div class="swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="image-container">
                        <div class="swiper-zoom-container">
                            <img src="${imageUrl}" alt="${imageAlt}" />
                            
                        </div>
                        <div class="popup-close"></div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    `);


        $('body').append(modal);

        modal.addClass('active');

        new Swiper('.zoom-modal .swiper', {
            modules: [SwipeZoom],
            zoom: true,
        });

        modal.on('click', function (e) {
            if ($(e.target).is('.zoom-modal')) {
                modal.remove();
            }
        });
    });
}

$(document).on('click', '.popup-close', function () {
    let modal = $(this).closest('.zoom-modal');
    modal.remove();
});
